import { Link, Flex, Text, Box, Drawer, Portal } from "@chakra-ui/react";

import { useLocation, useNavigate } from "react-router-dom";

export const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const navMenu = [
    {
      id: 1,
      title: "Home",
      path: "/",
      showInMobile: false,
    },
    {
      id: 2,
      title: "About",
      path: "/about",
      showInMobile: true,
    },
    {
      id: 3,
      title: "Events",
      path: "/events",
      showInMobile: true,
    },
  ];

  return (
    <Box fontFamily={"Raleway"}>
      <Flex
        display={{ base: "none", lg: "flex" }}
        borderWidth={"1px"}
        borderRadius={"50px"}
        borderColor={"#E7E8E9"}
        bg={"white"}
        pos={"absolute"}
        p="10px"
        top={"40px"}
        left={"50%"}
        transform={"translateX(-50%)"}
        shadow={"0 4px 6px rgba(0, 0, 0, 0.1)"}
        h={"68px"}
        align={"center"}
        zIndex={2}
      >
        {navMenu.map((item) => (
          <Box key={item.id} px="37px">
            <Link
              color={location.pathname === item.path ? "#0C111D" : "#667085"}
              href={item.path}
              fontWeight={600}
              fontSize={"16px"}
            >
              {item.title}
            </Link>
          </Box>
        ))}

        <Flex
          bg="black"
          borderRadius={"30px"}
          py="12px"
          px="37px"
          cursor={"pointer"}
          onClick={() =>
            window.open(
              "https://www.linkedin.com/in/udobong-ntia-b171871?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
              "_blank"
            )
          }
        >
          <Text fontSize={"16px"} fontWeight={600} color="white">
            LinkedIn
          </Text>
        </Flex>
      </Flex>

      <Flex
        display={{ base: "flex", lg: "none" }}
        align={"center"}
        justify={"space-between"}
        top={"40px"}
        pos={"fixed"}
        w={"100%"}
        px="16px"
        zIndex={2}
      >
        <Flex
          w="40px"
          h="40px"
          borderRadius={"8px"}
          bg={"white"}
          boxShadow="0 4px 6px rgba(0, 0, 0, 0.1)"
          align={"center"}
          justify={"center"}
          onClick={() => navigate("/")}
          cursor={"pointer"}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M19 19V9.79896L12 4.27696L5 9.79896V19H19ZM21 20C21 20.2652 20.8946 20.5195 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5195 3 20.2652 3 20V9.31396C2.99994 9.16291 3.0341 9.01381 3.09991 8.87785C3.16573 8.7419 3.26149 8.62261 3.38 8.52896L11.38 2.21796C11.5565 2.07845 11.775 2.00256 12 2.00256C12.225 2.00256 12.4435 2.07845 12.62 2.21796L20.62 8.52796C20.7386 8.62172 20.8345 8.74116 20.9003 8.8773C20.9661 9.01345 21.0002 9.16274 21 9.31396V20ZM7 12H9C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12H17C17 13.326 16.4732 14.5978 15.5355 15.5355C14.5979 16.4732 13.3261 17 12 17C10.6739 17 9.40215 16.4732 8.46447 15.5355C7.52678 14.5978 7 13.326 7 12Z"
              fill="#101828"
            />
          </svg>
        </Flex>

        <Drawer.Root size={"full"}>
          <Drawer.Trigger asChild>
            <Flex
              w="40px"
              h="40px"
              borderRadius={"8px"}
              bg={"white"}
              boxShadow="0 4px 6px rgba(0, 0, 0, 0.1)"
              align={"center"}
              justify={"center"}
              cursor={"pointer"}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M3 12H21M3 6H21M3 18H21"
                  stroke="#0C111D"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </Flex>
          </Drawer.Trigger>

          <Portal>
            <Drawer.Positioner>
              <Drawer.Content bg="white">
                <Drawer.Body px="0px">
                  <Flex
                    display={{ base: "flex", lg: "none" }}
                    align={"center"}
                    justify={"space-between"}
                    top={"40px"}
                    pos={"fixed"}
                    w={"100%"}
                    px="16px"
                    zIndex={2}
                  >
                    <Flex
                      w="40px"
                      h="40px"
                      borderRadius={"8px"}
                      bg={"white"}
                      boxShadow="0 4px 6px rgba(0, 0, 0, 0.1)"
                      align={"center"}
                      justify={"center"}
                      onClick={() => navigate("/")}
                      cursor={"pointer"}
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M19 19V9.79896L12 4.27696L5 9.79896V19H19ZM21 20C21 20.2652 20.8946 20.5195 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5195 3 20.2652 3 20V9.31396C2.99994 9.16291 3.0341 9.01381 3.09991 8.87785C3.16573 8.7419 3.26149 8.62261 3.38 8.52896L11.38 2.21796C11.5565 2.07845 11.775 2.00256 12 2.00256C12.225 2.00256 12.4435 2.07845 12.62 2.21796L20.62 8.52796C20.7386 8.62172 20.8345 8.74116 20.9003 8.8773C20.9661 9.01345 21.0002 9.16274 21 9.31396V20ZM7 12H9C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12H17C17 13.326 16.4732 14.5978 15.5355 15.5355C14.5979 16.4732 13.3261 17 12 17C10.6739 17 9.40215 16.4732 8.46447 15.5355C7.52678 14.5978 7 13.326 7 12Z"
                          fill="#101828"
                        />
                      </svg>
                    </Flex>

                    <Drawer.CloseTrigger
                      asChild
                      pos={"relative"}
                      top={"auto"}
                      right={"0px"}
                    >
                      <Flex
                        w="40px"
                        h="40px"
                        borderRadius={"8px"}
                        bg={"white"}
                        boxShadow="0 4px 6px rgba(0, 0, 0, 0.1)"
                        align={"center"}
                        justify={"center"}
                        cursor={"pointer"}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M3 12H21M3 6H21M3 18H21"
                            stroke="#0C111D"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </Flex>
                    </Drawer.CloseTrigger>
                  </Flex>

                  <Box mt="120px" px="16px">
                    {navMenu
                      .filter((item) => item.showInMobile)
                      .map((item) => (
                        <Box key={item.id} py="17px">
                          <Link
                            color={
                              location.pathname === item.path
                                ? "#0C111D"
                                : "#667085"
                            }
                            href={item.path}
                            fontWeight={600}
                            fontSize={"16px"}
                          >
                            {item.title}
                          </Link>
                        </Box>
                      ))}

                    <Box
                      h="1px"
                      my="24px"
                      bg={"#E5E8F0"}
                      mx="-16px"
                      opacity={0.4}
                    />

                    <Flex
                      bg="black"
                      borderRadius={"30px"}
                      py="12px"
                      px="37px"
                      cursor={"pointer"}
                      onClick={() =>
                        window.open(
                          "https://www.linkedin.com/in/udobong-ntia-b171871?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
                          "_blank"
                        )
                      }
                      justify={"center"}
                    >
                      <Text fontSize={"16px"} fontWeight={600} color="white">
                        LinkedIn
                      </Text>
                    </Flex>
                  </Box>
                </Drawer.Body>
              </Drawer.Content>
            </Drawer.Positioner>
          </Portal>
        </Drawer.Root>
      </Flex>
    </Box>
  );
};
